/* =========================================================
   トクキレ - NEWS（お知らせ）GAS連携 共通スクリプト（Shopify移植版）
   ---------------------------------------------------------
   Google Spreadsheet → GAS（JSON）から取得したお知らせを、
   1ファイルで3つの画面に描画する「ページ判別型」コントローラ。
   ロジックは旧Yahoo!サイト版(js/news.js)と同一。詳細ページのパスのみ
   Shopifyのページ構成(/pages/お知らせ)に合わせて変更している。

     ① TOPページ NEWSセクション   … #news-list-home（最新3件・本文なし・詳細へリンク）
     ② NEWS一覧ページ           … #news-list-page（全件・詳細へリンク）
     ③ NEWS詳細ページ           … #news-detail-article（?id= で1件表示）

   取得JSONの形式：
     [
       { "id":"NEWS-0001", "date":"2026/06/05",
         "title":"サイトリニューアルのお知らせ", "body":"本文…" },
       ...
     ]
   ========================================================= */
(function () {
  "use strict";

  // GAS ウェブアプリ（JSON）エンドポイント（末尾 /exec）
  // GAS側の isShopify 判定(publish列が「公開」または「shopifyのみ公開」)に対応する
  // 「site=shopify」を指定する。Yahoo!サイト側は site=yahoo のまま。
  var ENDPOINT =
    "https://script.google.com/macros/s/AKfycbzPUqdjbHLSr02b0y8eRsomkrB8H1M4m3pR_RvnFOWKf8YMeZ3q9ksX12iVeA3UhOlA/exec?site=shopify";

  var SITE_NAME = "トクキレ";
  var TOP_MAX = 3; // TOPの表示件数
  var LIST_PER_PAGE = 10; // 一覧ページの1ページあたり表示件数（超過分はページ送り）
  var DETAIL_PAGE = "/pages/お知らせ"; // 詳細ページのパス（Shopifyのページ）

  /* ---------- 共通ユーティリティ ---------- */

  // "2026/06/05" → "2026.06.05"（表示用）
  function toDisplayDate(date) {
    return String(date == null ? "" : date).replace(/[/-]/g, ".");
  }

  // "2026/06/05" → "2026-06-05"（time要素のdatetime / 比較用）
  function toDatetime(date) {
    return String(date == null ? "" : date).replace(/[/.]/g, "-");
  }

  // 指定文字数で省略（サロゲートペアも1文字として扱う）
  function truncate(text, max) {
    var str = String(text == null ? "" : text).trim();
    var chars = Array.from(str);
    if (chars.length <= max) return str;
    return chars.slice(0, max).join("") + "…";
  }

  // 日付の降順（新しい順）に並べ替え
  function sortByDateDesc(arr) {
    return arr.slice().sort(function (a, b) {
      return toDatetime(b && b.date).localeCompare(toDatetime(a && a.date));
    });
  }

  // URLパラメータ取得
  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  // 取得タイムアウト（ミリ秒）。GASの応答が遅い/止まった場合に無限待機を避ける
  var FETCH_TIMEOUT = 8000;

  /* ---------- ローカルキャッシュ（stale-while-revalidate） ----------
     GASウェブアプリの応答は毎回2〜4秒かかる。お知らせは更新頻度が低いので、
     取得結果をブラウザ（localStorage）に保存しておき、2回目以降の訪問では
     まず保存済みを即時表示（待ち時間ゼロ）→ 裏で最新を取り直し、内容が
     変わっていれば差し替える。これで体感速度を大きく改善する。
     ・ENDPOINT 単位でキー分け（site違いを混在させない）
     ・破損や容量超過は握りつぶしてネットワーク取得にフォールバック     */
  var CACHE_KEY = "tokukire_news_v1:" + ENDPOINT;

  function readCache() {
    try {
      var raw = window.localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !Array.isArray(obj.data)) return null;
      return obj; // { savedAt:number, data:Array }
    } catch (e) {
      return null;
    }
  }

  function writeCache(data) {
    try {
      window.localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ savedAt: Date.now(), data: data })
      );
    } catch (e) {
      /* localStorage非対応・容量超過時は何もしない（取得自体は成功している） */
    }
  }

  // キャッシュ即時表示 → ネットワーク再取得 → 変化時のみ再描画
  //   onData(data, source)  source: "cache" | "network"
  //   onError(err)          キャッシュも無く取得も失敗したときだけ呼ぶ
  function loadNews(onData, onError) {
    var cached = readCache();
    var shownFromCache = false;

    if (cached) {
      shownFromCache = true;
      try {
        onData(cached.data, "cache");
      } catch (e) {
        if (window.console) console.error(e);
      }
    }

    fetchNews()
      .then(function (data) {
        var changed =
          !cached || JSON.stringify(cached.data) !== JSON.stringify(data);
        writeCache(data);
        // 内容が変わっていなければ再描画しない（チラつき防止）
        if (changed) onData(data, "network");
      })
      .catch(function (err) {
        // キャッシュを既に表示できていれば、再取得失敗は黙ってログのみ
        if (shownFromCache) {
          if (window.console)
            console.warn("NEWS再取得に失敗（キャッシュ表示を継続）:", err);
          return;
        }
        if (onError) onError(err);
      });
  }

  // GASからJSON取得（配列で返らなければエラー）
  // ・AbortController でタイムアウトを設け、応答が無いときは早めに失敗させてフォールバックさせる
  // ・AbortController 非対応の古い環境では従来どおりタイムアウト無しでfetchする
  function fetchNews() {
    var controller =
      typeof AbortController !== "undefined" ? new AbortController() : null;
    var options = { cache: "no-store" };
    var timer = null;
    if (controller) {
      options.signal = controller.signal;
      timer = setTimeout(function () {
        controller.abort();
      }, FETCH_TIMEOUT);
    }

    function clear() {
      if (timer) clearTimeout(timer);
    }

    return fetch(ENDPOINT, options)
      .then(function (res) {
        if (!res.ok) throw new Error("HTTP " + res.status);
        return res.json();
      })
      .then(function (data) {
        clear();
        if (!Array.isArray(data)) throw new Error("不正なデータ形式です");
        return data;
      })
      .catch(function (err) {
        clear();
        // タイムアウト(abort)時はわかりやすいメッセージに変換して再throw（呼び出し側のcatchで処理）
        if (err && err.name === "AbortError") {
          throw new Error("お知らせの取得がタイムアウトしました");
        }
        throw err;
      });
  }

  // プレーンテキスト本文を安全にDOM化（改行を保持・XSS対策で textContent 使用）
  function appendParagraphs(container, text) {
    String(text == null ? "" : text)
      .split(/\n{2,}/) // 空行で段落分け
      .forEach(function (block) {
        var p = document.createElement("p");
        block.split(/\n/).forEach(function (line, i) {
          if (i) p.appendChild(document.createElement("br"));
          p.appendChild(document.createTextNode(line));
        });
        container.appendChild(p);
      });
  }

  // meta タグ更新（SEO/OGP）
  function setMeta(attr, key, value) {
    var el = document.head.querySelector("meta[" + attr + '="' + key + '"]');
    if (el && value) el.setAttribute("content", value);
  }

  // ローディング / エラー / 空 表示の切り替え
  function setState(el, kind, message) {
    if (!el) return;
    el.hidden = false;
    el.textContent = message;
    el.className = "news-state news-state--" + kind;
  }
  function clearState(el) {
    if (!el) return;
    el.hidden = true;
    el.textContent = "";
    el.className = "news-state";
  }

  // 詳細ページへのリンクを生成
  function detailHref(id) {
    return DETAIL_PAGE + "?id=" + encodeURIComponent(id);
  }

  /* ---------- ① TOPページ NEWSセクション ---------- */
  function renderTop() {
    var list = document.getElementById("news-list-home");
    if (!list) return;
    var section = document.getElementById("news-section");

    loadNews(
      function (data) {
        var items = sortByDateDesc(data).slice(0, TOP_MAX);
        var frag = document.createDocumentFragment();

        items.forEach(function (item) {
          if (!item || !item.id) return;
          var li = document.createElement("li");
          li.className = "news__item";

          var a = document.createElement("a");
          a.className = "news__link";
          a.href = detailHref(item.id);

          var time = document.createElement("time");
          time.className = "news__date";
          time.setAttribute("datetime", toDatetime(item.date));
          time.textContent = toDisplayDate(item.date);

          var title = document.createElement("span");
          title.className = "news__title";
          title.textContent = item.title || "";

          a.appendChild(time);
          a.appendChild(title);
          li.appendChild(a);
          frag.appendChild(li);
        });

        // 0件・描画対象なしはセクションごと非表示
        if (!frag.childNodes.length) {
          if (section) section.hidden = true;
          return;
        }
        list.innerHTML = "";
        list.appendChild(frag);
        if (section) section.hidden = false;
      },
      function (err) {
        // TOPは失敗時セクションごと非表示（崩れ防止）
        if (window.console) console.error("NEWS取得に失敗:", err);
        if (section) section.hidden = true;
      }
    );
  }

  /* ---------- ② NEWS一覧ページ ----------
     表示はタイトル＋日付のみ（本文抜粋なし＝一覧を軽く・新しい順を素早く表示）。
     本文は詳細ページでのみ読み込む。
     LIST_PER_PAGE 件ごとにページ送り。取得済みデータを保持し、
     ページ切替時は再取得せずクライアント側で描画（?page= で状態を保持）。 */

  // 一覧の1項目（li）を生成：タイトルと日付のみ
  function buildListItem(item) {
    var li = document.createElement("li");
    li.className = "news-archive__item";

    var a = document.createElement("a");
    a.className = "news-archive__link";
    a.href = detailHref(item.id);

    var time = document.createElement("time");
    time.className = "news-archive__date";
    time.setAttribute("datetime", toDatetime(item.date));
    time.textContent = toDisplayDate(item.date);

    var title = document.createElement("span");
    title.className = "news-archive__title";
    title.textContent = item.title || "";

    a.appendChild(time);
    a.appendChild(title);
    li.appendChild(a);
    return li;
  }

  // ページ送りリンク（前へ／番号／次へ）を描画
  function renderPager(nav, currentPage, totalPages, onSelect) {
    if (!nav) return;
    if (totalPages <= 1) {
      nav.hidden = true;
      nav.innerHTML = "";
      return;
    }
    nav.hidden = false;
    nav.innerHTML = "";
    var frag = document.createDocumentFragment();

    // 前へ／次へ（端では無効化した span を置く）
    function addStep(label, targetPage, disabled, modifier) {
      var cls = "news-pager__step news-pager__step--" + modifier;
      if (disabled) {
        var span = document.createElement("span");
        span.className = cls + " is-disabled";
        span.setAttribute("aria-hidden", "true");
        span.textContent = label;
        frag.appendChild(span);
        return;
      }
      var a = document.createElement("a");
      a.className = cls;
      a.href = "?page=" + targetPage;
      a.textContent = label;
      a.addEventListener("click", function (e) {
        e.preventDefault();
        onSelect(targetPage);
      });
      frag.appendChild(a);
    }

    addStep("前へ", currentPage - 1, currentPage <= 1, "prev");

    for (var p = 1; p <= totalPages; p++) {
      (function (page) {
        if (page === currentPage) {
          var cur = document.createElement("span");
          cur.className = "news-pager__num is-current";
          cur.setAttribute("aria-current", "page");
          cur.textContent = String(page);
          frag.appendChild(cur);
          return;
        }
        var a = document.createElement("a");
        a.className = "news-pager__num";
        a.href = "?page=" + page;
        a.setAttribute("aria-label", page + "ページ目へ");
        a.textContent = String(page);
        a.addEventListener("click", function (e) {
          e.preventDefault();
          onSelect(page);
        });
        frag.appendChild(a);
      })(p);
    }

    addStep("次へ", currentPage + 1, currentPage >= totalPages, "next");

    nav.appendChild(frag);
  }

  function renderList() {
    var list = document.getElementById("news-list-page");
    if (!list) return;
    var state = document.getElementById("news-state");
    var pager = document.getElementById("news-pager");
    var head = document.getElementById("news-archive-title");

    setState(state, "loading", "お知らせを読み込んでいます…");

    loadNews(
      function (data) {
        var items = sortByDateDesc(data).filter(function (item) {
          return item && item.id;
        });

        if (!items.length) {
          list.innerHTML = "";
          if (pager) {
            pager.hidden = true;
            pager.innerHTML = "";
          }
          setState(state, "empty", "現在お知らせはありません。");
          return;
        }
        clearState(state);

        var totalPages = Math.max(1, Math.ceil(items.length / LIST_PER_PAGE));

        // 指定ページを描画（scroll=true で一覧見出しへスクロール）
        function showPage(page, scroll) {
          page = Math.min(Math.max(1, page || 1), totalPages);
          var start = (page - 1) * LIST_PER_PAGE;
          var pageItems = items.slice(start, start + LIST_PER_PAGE);

          var frag = document.createDocumentFragment();
          pageItems.forEach(function (item) {
            frag.appendChild(buildListItem(item));
          });
          list.innerHTML = "";
          list.appendChild(frag);

          renderPager(pager, page, totalPages, function (next) {
            // URLを ?page= で更新（戻る／進む・ブックマークに対応）
            var url = window.location.pathname + (next <= 1 ? "" : "?page=" + next);
            window.history.pushState({ page: next }, "", url);
            showPage(next, true);
          });

          if (scroll && head) {
            head.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }

        var initialPage = parseInt(getParam("page"), 10) || 1;
        showPage(initialPage, false);

        // ブラウザの戻る／進むでページ状態を復元（多重登録を防ぐ）
        if (!renderList._popstateBound) {
          renderList._popstateBound = true;
          window.addEventListener("popstate", function () {
            var p = parseInt(getParam("page"), 10) || 1;
            // 最新の描画クロージャ（キャッシュ→ネットワーク更新後も追従）
            if (renderList._showPage) renderList._showPage(p, false);
          });
        }
        renderList._showPage = showPage;
      },
      function (err) {
        if (window.console) console.error(err);
        list.innerHTML = "";
        if (pager) {
          pager.hidden = true;
          pager.innerHTML = "";
        }
        setState(
          state,
          "error",
          "お知らせの取得に失敗しました。時間をおいて再度お試しください。"
        );
      }
    );
  }

  /* ---------- ③ NEWS詳細ページ（?id=） ---------- */
  function renderDetail() {
    var root = document.getElementById("news-detail-article");
    if (!root) return;
    var state = document.getElementById("news-state");
    var id = getParam("id");

    if (!id) {
      root.hidden = true;
      setState(state, "error", "お知らせが指定されていません。");
      return;
    }

    setState(state, "loading", "お知らせを読み込んでいます…");

    loadNews(
      function (data) {
        var item = null;
        for (var i = 0; i < data.length; i++) {
          if (data[i] && String(data[i].id) === String(id)) {
            item = data[i];
            break;
          }
        }

        if (!item) {
          root.hidden = true;
          setState(state, "error", "お知らせが見つかりませんでした。");
          return;
        }
        clearState(state);

        // パンくず（現在地）
        var current = document.getElementById("news-detail-current");
        if (current) current.textContent = item.title || "";

        // 投稿日
        var dateEl = document.getElementById("news-detail-date");
        if (dateEl) {
          dateEl.setAttribute("datetime", toDatetime(item.date));
          dateEl.textContent = toDisplayDate(item.date);
        }

        // タイトル
        var titleEl = document.getElementById("news-detail-title");
        if (titleEl) titleEl.textContent = item.title || "";

        // 本文全文（プレーンテキスト → 段落・改行を保持）
        var bodyEl = document.getElementById("news-detail-body");
        if (bodyEl) {
          bodyEl.innerHTML = "";
          appendParagraphs(bodyEl, item.body);
        }

        // SEO / OGP（クライアント描画のため補助的に更新）
        if (item.title) {
          var pageTitle = item.title + "｜" + SITE_NAME;
          document.title = pageTitle;
          setMeta("property", "og:title", pageTitle);
        }
        if (item.body) {
          var desc = truncate(item.body, 120);
          setMeta("name", "description", desc);
          setMeta("property", "og:description", desc);
        }

        root.hidden = false;
      },
      function (err) {
        if (window.console) console.error(err);
        root.hidden = true;
        setState(
          state,
          "error",
          "お知らせの取得に失敗しました。時間をおいて再度お試しください。"
        );
      }
    );
  }

  /* ---------- 初期化（ページ判別） ---------- */
  function init() {
    renderTop();
    renderList();
    renderDetail();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
